export const categories = [
  {
    id: 'seoul',
    name: '首尔漫游',
    slug: 'seoul',
    description: '探索首尔最热门的打卡圣地，感受这座不夜城的无限魅力',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Seoul%20cityscape%20with%20colorful%20neon%20signs%20and%20modern%20architecture%20at%20night%2C%20young%20travelers%20walking%20on%20busy%20streets%2C%20vibrant%20urban%20atmosphere%2C%20warm%20golden%20and%20pink%20neon%20lighting%2C%20editorial%20travel%20photography%2C%20soft%20shadows%2C%20cinematic%20mood&width=800&height=500&seq=cat-seoul-01&orientation=landscape',
    articleCount: 18,
  },
  {
    id: 'food',
    name: '美食探店',
    slug: 'food',
    description: '从街头小吃到米其林餐厅，带你吃遍韩国地道美味',
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20street%20food%20market%20with%20colorful%20food%20stalls%2C%20tteokbokki%20and%20hotteok%20being%20cooked%2C%20warm%20evening%20light%2C%20young%20people%20enjoying%20food%2C%20cozy%20atmosphere%2C%20editorial%20food%20photography%2C%20warm%20terracotta%20and%20golden%20tones&width=800&height=500&seq=cat-food-01&orientation=landscape',
    articleCount: 15,
  },
  {
    id: 'shopping',
    name: '购物攻略',
    slug: 'shopping',
    description: '明洞、弘大、江南，韩国购物天堂一站式指南',
    icon: 'ri-shopping-bag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cosmetics%20and%20fashion%20shopping%20district%20with%20colorful%20storefronts%2C%20young%20shoppers%20carrying%20shopping%20bags%2C%20modern%20Korean%20beauty%20products%20displayed%2C%20bright%20daytime%20scene%2C%20clean%20editorial%20style%2C%20soft%20pink%20and%20cream%20tones&width=800&height=500&seq=cat-shop-01&orientation=landscape',
    articleCount: 12,
  },
  {
    id: 'kpop',
    name: '韩流追星',
    slug: 'kpop',
    description: 'K-POP粉丝必看！打卡偶像同款地点与经纪公司路线',
    icon: 'ri-music-2-line',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20concert%20venue%20exterior%20with%20colorful%20fan%20banners%20and%20light%20sticks%2C%20young%20fans%20gathering%20excitedly%2C%20modern%20entertainment%20building%20facade%2C%20vibrant%20pink%20and%20purple%20evening%20sky%2C%20editorial%20photography%2C%20dynamic%20atmosphere&width=800&height=500&seq=cat-kpop-01&orientation=landscape',
    articleCount: 14,
  },
  {
    id: 'jeju',
    name: '济州岛',
    slug: 'jeju',
    description: '韩国夏威夷的绝美风光，自然与治愈的完美假期',
    icon: 'ri-ship-line',
    image: 'https://readdy.ai/api/search-image?query=Jeju%20Island%20scenic%20coastal%20view%20with%20volcanic%20rock%20formations%20and%20turquoise%20sea%2C%20canola%20flower%20fields%20in%20spring%2C%20young%20couple%20walking%20along%20seaside%20path%2C%20bright%20sunny%20day%2C%20soft%20warm%20natural%20lighting%2C%20editorial%20travel%20photography&width=800&height=500&seq=cat-jeju-01&orientation=landscape',
    articleCount: 10,
  },
  {
    id: 'culture',
    name: '文化体验',
    slug: 'culture',
    description: '穿韩服、学韩语、体验传统工艺，深度感受韩国文化',
    icon: 'ri-landscape-line',
    image: 'https://readdy.ai/api/search-image?query=Young%20people%20wearing%20colorful%20hanbok%20traditional%20Korean%20clothing%20at%20Gyeongbokgung%20Palace%2C%20traditional%20architecture%20background%2C%20warm%20autumn%20afternoon%20light%2C%20cultural%20experience%2C%20editorial%20photography%2C%20soft%20cream%20and%20terracotta%20tones&width=800&height=500&seq=cat-culture-01&orientation=landscape',
    articleCount: 8,
  },
];

export const articles = [
  {
    id: 1,
    title: '2024首尔必去十大网红打卡地，拍出人生照片',
    slug: 'seoul-top-10-instagram-spots-2024',
    category: 'seoul',
    excerpt: '从圣水洞咖啡街到南山塔夜景，精选首尔最出片的打卡圣地，让你的朋友圈秒变韩系画报。',
    content: `首尔，这座永远年轻的城市，每一个转角都可能藏着惊喜。对于热爱记录生活的年轻人来说，首尔简直就是一座巨大的摄影棚。

## 1. 圣水洞咖啡街

曾经的工业区摇身一变，成为首尔最炙手可热的潮流圣地。红砖厂房改造的独立咖啡馆，每一家都有独特的装修风格。推荐下午3-4点前往，阳光透过大窗户洒进来，光影效果绝佳。

## 2. 益善洞韓屋胡同

窄窄的巷弄里藏着上百年的韩屋，现在变身为精致的小店和咖啡馆。傍晚时分灯笼亮起，氛围感拉满，穿上韩服来这里拍照，仿佛穿越回旧时光。

## 3. 南山首尔塔

首尔的地标性建筑，不要只拍白天的塔，夜晚的灯光秀才是精髓。在爱情锁墙前挂上属于你的锁，顺便俯瞰整个首尔的璀璨夜景。

## 4. 景福宫

穿韩服免费入场的福利怎么能错过？红墙绿瓦配上传统服饰，出片率百分之百。建议选亮色韩服，在红墙前特别上镜。

## 5. 弘大街头

年轻人的天堂，街头表演、涂鸦墙、潮流店铺随处可见。每周末的自由市场更是淘宝天堂，独立设计师的作品独一无二。

## 6. 梨泰院解放村

这里是首尔的"小欧洲"，山坡上的彩色房子层层叠叠。找一家屋顶咖啡坐下，一边喝咖啡一边看日落，随手一拍都是文艺大片。

## 7. 盘浦汉江公园

汉江边上的城市绿洲，租一张野餐垫，叫一份炸鸡外卖，和朋友们在草坪上享受悠闲时光。夜晚的彩虹喷泉秀绝对不能错过。

## 8. 东大门设计广场DDP

扎哈·哈迪德设计的未来感建筑，流线型的外观在任何光线下都很上镜。这里经常举办各种展览和活动，记得提前查看日程。

## 9. 北村韩屋村

传统韩屋聚集区，依山而建的屋脊层层叠叠。清晨人少的时候来，能拍到最纯净的画面。但记得这里是居民区，保持安静哦。

## 10. 三清洞

文艺小资的最爱，整条街都是设计师店铺、独立画廊和精致小馆。秋天的银杏树配上韩屋屋顶，美得像画一样。

每个打卡地都有最佳拍摄时间和角度，建议提前做好功课，避开人流高峰。首尔是一座值得慢慢品味的城市，别急着赶景点，偶尔在路边的小巷里迷路，也许会有意外的惊喜。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20traveler%20taking%20photo%20at%20colorful%20Seoul%20cafe%20street%20with%20neon%20signs%2C%20instagrammable%20spot%2C%20trendy%20Korean%20fashion%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20travel%20photography%2C%20soft%20pink%20and%20cream%20tones&width=1200&height=675&seq=article-seoul-spots&orientation=landscape',
    author: '小韩',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20friendly%20look&width=200&height=200&seq=avatar-xiaohan&orientation=squarish',
    publishDate: '2024-12-15',
    readTime: 8,
    tags: ['首尔', '打卡', '拍照', '网红地', '旅行攻略'],
  },
  {
    id: 2,
    title: '弘大美食地图：韩国年轻人真正爱吃的12家店',
    slug: 'hongdae-food-map-12-restaurants',
    category: 'food',
    excerpt: '避开游客陷阱，跟着弘大学生吃遍最地道的韩国料理，从烤肉到甜品一网打尽。',
    content: `弘大，不仅是潮流文化的中心，更是美食的聚集地。但面对琳琅满目的餐厅，哪些才是真正值得排队的好店？我们探访了弘大附近12家韩国年轻人常去的餐厅，给你一份最真实的美食地图。

## 烤肉篇

**1. 站着吃的烤肉 - 延南洞炭火烤肉**

这家店真的需要站着吃！新鲜的韩牛在炭火上滋滋作响，配上特制的酱料和生菜，一口下去满满的幸福感。人均约30000韩元，性价比极高。

**2. 八色五花肉**

八种不同腌料的五花肉，从人参到红酒，每种口味都各有特色。套餐里还包含大酱汤和蒸蛋，份量十足，两个人吃到撑。

## 街头小吃篇

**3. 弘大鸡蛋面包**

位于弘大主街的小摊位，从早排到晚。松软的蛋糕体包裹着一整颗鸡蛋，表面撒上芝士，趁热吃简直绝了。

**4. 辣炒年糕天국**

韩国年轻人放学后的必吃小吃，年糕Q弹入味，鱼饼和鸡蛋的搭配经典到不行。加一份炸物拼盘，就是完美的街头午餐。

## 特色餐厅

**5. 延南洞猪蹄**

分量大到惊人的猪蹄店，猪蹄炖得软烂入味，配上韭菜和蒜片，包在生菜里一口一个。记得点他们家的手抓饭团，蒜香味十足。

## 甜品咖啡篇

**6. Thanks Nature Cafe**

弘大最有名的绵羊咖啡馆！两只超级可爱的绵羊在店内自由走动，你可以一边喝咖啡一边撸羊。布朗尼和提拉米苏都很推荐。

弘大的美食远不止这些，每条小巷都可能藏着惊喜。建议避开午晚餐高峰期，或者做好排队的心理准备。但相信我，每一分钟的等待都是值得的！`,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BBQ%20restaurant%20with%20sizzling%20meat%20on%20grill%2C%20colorful%20banchan%20side%20dishes%2C%20young%20people%20enjoying%20meal%2C%20warm%20cozy%20interior%20lighting%2C%20appetizing%20food%20photography%2C%20terracotta%20and%20warm%20golden%20tones&width=1200&height=675&seq=article-hongdae-food&orientation=landscape',
    author: '吃货小花',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20bright%20smile%20portrait%2C%20warm%20natural%20studio%20lighting%2C%20cream%20background%2C%20friendly%20expression%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-xiaohua&orientation=squarish',
    publishDate: '2024-12-10',
    readTime: 10,
    tags: ['弘大', '美食', '烤肉', '街头小吃', '甜品'],
  },
  {
    id: 3,
    title: '明洞vs弘大vs江南：韩国三大商圈购物全攻略',
    slug: 'myeongdong-hongdae-gangnam-shopping-guide',
    category: 'shopping',
    excerpt: '不同预算、不同风格，找到最适合你的购物天堂。化妆品、潮牌、奢侈品一篇搞定。',
    content: `韩国是购物的天堂，但面对明洞、弘大、江南三大商圈，到底该去哪里买什么？这篇攻略帮你理清思路。

## 明洞：美妆护肤主战场

作为韩国最著名的购物区，明洞绝对是美妆爱好者的第一站。几乎你能想到的所有韩国美妆品牌都在这里设有旗舰店。

**必买清单：**
- Olive Young：韩国版屈臣氏，一站式购齐所有热门产品
- 3CE旗舰店：彩妆控的朝圣地
- Innisfree明洞旗舰店：可以DIY定制属于你的护肤品

**购物技巧：** 大部分店铺满30000韩元即可退税，记得随身携带护照。很多店铺门口会有免费样品派发，大胆去拿！

## 弘大：潮流个性淘宝

弘大是年轻人文化的发源地，这里的购物体验更加个性化。

**必逛区域：**
- 弘大自由市场：每周六下午，独立设计师摆摊卖手作
- 延南洞小巷：隐藏着无数小众买手店
- Wonder Place：集合店形式，可以买到各种韩国本土潮牌

## 江南：奢侈品与高端体验

预算充足的话，江南区是你不二的选择。

**购物路线：**
- 狎鸥亭罗德奥：国际奢侈品牌旗舰店一条街
- 清潭洞：韩国顶级买手店聚集地
- COEX Mall：亚洲最大的地下购物中心

无论你是美妆控、潮牌迷还是奢侈品爱好者，韩国都能满足你的购物欲。记得带一个空箱子来，因为你一定会装满回去！`,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20shopping%20district%20with%20colorful%20cosmetic%20storefronts%20and%20fashion%20boutiques%2C%20young%20shoppers%20with%20shopping%20bags%2C%20modern%20urban%20street%2C%20bright%20daytime%20scene%2C%20editorial%20style%2C%20soft%20pink%20and%20cream%20tones&width=1200&height=675&seq=article-shopping&orientation=landscape',
    author: '买买买小琳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20stylish%20look%20portrait%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20modern%20editorial%20photography%2C%20professional%20smile&width=200&height=200&seq=avatar-xiaolin&orientation=squarish',
    publishDate: '2024-12-08',
    readTime: 7,
    tags: ['购物', '明洞', '弘大', '江南', '化妆品'],
  },
  {
    id: 4,
    title: 'K-POP粉丝首尔追星全攻略：从经纪公司到偶像同款餐厅',
    slug: 'kpop-fan-seoul-pilgrimage-guide',
    category: 'kpop',
    excerpt: '探访SM、JYP、HYBE等顶级经纪公司，打卡偶像同款餐厅和咖啡厅，让你的追星之旅不留遗憾。',
    coverImage: 'https://readdy.ai/api/search-image?query=Kpop%20entertainment%20company%20building%20with%20colorful%20fan%20art%20and%20banners%20outside%2C%20young%20fans%20taking%20photos%2C%20modern%20building%20facade%2C%20bright%20daytime%2C%20editorial%20photography%2C%20soft%20pink%20and%20cream%20tones&width=1200&height=675&seq=article-kpop&orientation=landscape',
    author: '追星少女阿圆',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20excited%20expression%20portrait%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20kpop%20fan%20style%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-ayuan&orientation=squarish',
    publishDate: '2024-12-05',
    readTime: 12,
    tags: ['K-POP', '追星', '经纪公司', '偶像', 'SM', 'HYBE'],
  },
  {
    id: 5,
    title: '济州岛三天两夜自驾攻略：最美的风景都在路上',
    slug: 'jeju-island-3-day-road-trip',
    category: 'jeju',
    excerpt: '租一辆车，沿着海岸公路一路开下去，发现那些旅行团永远不会带你去的小众秘境。',
    coverImage: 'https://readdy.ai/api/search-image?query=Jeju%20Island%20coastal%20road%20with%20rental%20car%2C%20turquoise%20ocean%20view%2C%20canola%20flowers%20along%20roadside%2C%20bright%20sunny%20spring%20day%2C%20editorial%20travel%20photography%2C%20warm%20golden%20and%20green%20tones&width=1200&height=675&seq=article-jeju&orientation=landscape',
    author: '自驾达人阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20adventurous%20look%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20casual%20outdoor%20style%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-ajie&orientation=squarish',
    publishDate: '2024-12-01',
    readTime: 10,
    tags: ['济州岛', '自驾', '三天两夜', '海岸公路', '小众景点'],
  },
  {
    id: 6,
    title: '韩服体验全指南：景福宫免费入场+最佳拍照路线',
    slug: 'hanbok-experience-gyeongbokgung-guide',
    category: 'culture',
    excerpt: '穿韩服游景福宫不仅免门票，还能拍出绝美人生照片。从租赁到拍摄，看这篇就够了。',
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20couple%20wearing%20beautiful%20colorful%20hanbok%20at%20Gyeongbokgung%20Palace%20courtyard%2C%20traditional%20Korean%20architecture%20background%2C%20warm%20golden%20afternoon%20light%2C%20editorial%20photography%2C%20soft%20cream%20and%20terracotta%20tones&width=1200&height=675&seq=article-hanbok&orientation=landscape',
    author: '小韩',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20friendly%20look&width=200&height=200&seq=avatar-xiaohan&orientation=squarish',
    publishDate: '2024-11-28',
    readTime: 6,
    tags: ['韩服', '景福宫', '传统文化', '拍照', '体验'],
  },
  {
    id: 7,
    title: '首尔隐藏版咖啡地图：10家只有当地人才知道的宝藏咖啡馆',
    slug: 'seoul-hidden-cafe-map',
    category: 'seoul',
    excerpt: '从延南洞的屋顶天台到圣水洞的旧工厂改造，这些咖啡馆不止好喝更好拍。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20Korean%20rooftop%20cafe%20with%20plants%20and%20warm%20wooden%20interior%2C%20latte%20art%20coffee%20on%20table%2C%20young%20people%20chatting%2C%20soft%20afternoon%20sunlight%20through%20windows%2C%20editorial%20cafe%20photography%2C%20warm%20terracotta%20and%20cream%20tones&width=1200&height=675&seq=article-cafe&orientation=landscape',
    author: '小韩',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20friendly%20look&width=200&height=200&seq=avatar-xiaohan&orientation=squarish',
    publishDate: '2024-11-25',
    readTime: 9,
    tags: ['咖啡馆', '首尔', '圣水洞', '延南洞', '探店'],
  },
  {
    id: 8,
    title: '韩国便利店必买清单：GS25、CU、7-11完全指南',
    slug: 'korean-convenience-store-must-buy',
    category: 'food',
    excerpt: '韩国便利店就是一座美食宝库！从网红三明治到限定零食，每一款都值得尝试。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20convenience%20store%20interior%20with%20colorful%20snacks%20and%20drinks%20on%20shelves%2C%20young%20person%20selecting%20items%2C%20bright%20clean%20lighting%2C%20editorial%20style%2C%20soft%20cream%20and%20warm%20tones&width=1200&height=675&seq=article-convenience&orientation=landscape',
    author: '吃货小花',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20bright%20smile%20portrait%2C%20warm%20natural%20studio%20lighting%2C%20cream%20background%2C%20friendly%20expression%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-xiaohua&orientation=squarish',
    publishDate: '2024-11-22',
    readTime: 7,
    tags: ['便利店', '零食', 'GS25', 'CU', '必买'],
  },
  {
    id: 9,
    title: '江南狎鸥亭一日游：从奢侈大牌到小众买手店',
    slug: 'gangnam-apgujeong-shopping-day',
    category: 'shopping',
    excerpt: '感受韩国最顶级购物区的奢华氛围，搭配周边美食和咖啡，度过精致的一天。',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20shopping%20street%20in%20Gangnam%20Seoul%20with%20designer%20boutiques%20and%20modern%20architecture%2C%20stylish%20young%20people%20walking%2C%20sunny%20day%2C%20editorial%20fashion%20photography%2C%20cream%20and%20champagne%20tones&width=1200&height=675&seq=article-gangnam&orientation=landscape',
    author: '买买买小琳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20stylish%20look%20portrait%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20modern%20editorial%20photography%2C%20professional%20smile&width=200&height=200&seq=avatar-xiaolin&orientation=squarish',
    publishDate: '2024-11-20',
    readTime: 8,
    tags: ['江南', '奢侈品', '买手店', '狎鸥亭', '购物'],
  },
  {
    id: 10,
    title: '韩国地铁完全指南：T-money卡+APP+换乘技巧全攻略',
    slug: 'korea-subway-complete-guide',
    category: 'seoul',
    excerpt: '第一次坐韩国地铁也不用慌！从买卡充值到APP导航，手把手教你玩转韩国地铁。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Seoul%20subway%20station%20interior%20with%20colorful%20line%20maps%20and%20young%20travelers%2C%20clean%20bright%20underground%20scene%2C%20editorial%20travel%20photography%2C%20soft%20natural%20lighting%2C%20cream%20and%20warm%20gray%20tones&width=1200&height=675&seq=article-subway&orientation=landscape',
    author: '小韩',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20friendly%20look&width=200&height=200&seq=avatar-xiaohan&orientation=squarish',
    publishDate: '2024-11-18',
    readTime: 8,
    tags: ['地铁', '交通', 'T-money', '首尔', '攻略'],
  },
  {
    id: 11,
    title: '偶像生日应援咖啡厅打卡指南：如何找到并享受应援活动',
    slug: 'idol-birthday-cafe-support-guide',
    category: 'kpop',
    excerpt: '偶像生日季就是粉丝的狂欢节！教你如何找到应援咖啡厅，收获满满的小卡和周边。',
    coverImage: 'https://readdy.ai/api/search-image?query=Kpop%20idol%20birthday%20support%20cafe%20with%20fans%20taking%20photos%20of%20decorated%20interior%2C%20cup%20sleeves%20and%20photo%20cards%20displayed%2C%20warm%20cozy%20cafe%20atmosphere%2C%20pink%20and%20cream%20tones%2C%20editorial%20photography&width=1200&height=675&seq=article-support-cafe&orientation=landscape',
    author: '追星少女阿圆',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20excited%20expression%20portrait%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20kpop%20fan%20style%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-ayuan&orientation=squarish',
    publishDate: '2024-11-15',
    readTime: 6,
    tags: ['应援', 'K-POP', '生日', '咖啡厅', '粉丝'],
  },
  {
    id: 12,
    title: '济州岛必吃的10大美食：黑猪肉、海鲜锅与柑橘甜品',
    slug: 'jeju-island-must-eat-food',
    category: 'jeju',
    excerpt: '离开首尔，济州岛的美食世界同样精彩。从地道的黑猪肉到新鲜的鲍鱼粥，吃遍济州。',
    coverImage: 'https://readdy.ai/api/search-image?query=Jeju%20black%20pork%20BBQ%20on%20grill%20with%20colorful%20banchan%2C%20fresh%20seafood%20stew%20in%20clay%20pot%2C%20restaurant%20with%20ocean%20view%2C%20warm%20cozy%20atmosphere%2C%20editorial%20food%20photography%2C%20terracotta%20and%20golden%20tones&width=1200&height=675&seq=article-jeju-food&orientation=landscape',
    author: '吃货小花',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20bright%20smile%20portrait%2C%20warm%20natural%20studio%20lighting%2C%20cream%20background%2C%20friendly%20expression%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-xiaohua&orientation=squarish',
    publishDate: '2024-11-12',
    readTime: 9,
    tags: ['济州岛', '美食', '黑猪肉', '海鲜', '甜品'],
  },
  {
    id: 13,
    title: '韩国传统市场巡礼：广藏市场、通仁市场美食大比拼',
    slug: 'korean-traditional-market-tour',
    category: 'culture',
    excerpt: '传统市场才是韩国美食的灵魂所在，跟着本地人排队就对了。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20traditional%20market%20with%20colorful%20food%20stalls%20and%20busy%20vendors%2C%20steaming%20food%2C%20warm%20evening%20lighting%2C%20young%20travelers%20exploring%2C%20vibrant%20atmosphere%2C%20editorial%20photography%2C%20terracotta%20and%20golden%20tones&width=1200&height=675&seq=article-market&orientation=landscape',
    author: '小韩',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20portrait%20photography%2C%20professional%20yet%20friendly%20look&width=200&height=200&seq=avatar-xiaohan&orientation=squarish',
    publishDate: '2024-11-10',
    readTime: 7,
    tags: ['传统市场', '广藏市场', '通仁市场', '美食', '文化'],
  },
  {
    id: 14,
    title: '春川&南怡岛一日游：首尔出发的完美近郊路线',
    slug: 'chuncheon-nami-island-day-trip',
    category: 'jeju',
    excerpt: '冬季恋歌拍摄地南怡岛，加上春川的辣炒鸡排，一天时间刚刚好。',
    coverImage: 'https://readdy.ai/api/search-image?query=Nami%20Island%20tree-lined%20avenue%20in%20autumn%20with%20colorful%20foliage%2C%20young%20couple%20walking%20hand%20in%20hand%2C%20romantic%20atmosphere%2C%20warm%20golden%20afternoon%20light%2C%20editorial%20travel%20photography&width=1200&height=675&seq=article-nami&orientation=landscape',
    author: '自驾达人阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20adventurous%20look%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20casual%20outdoor%20style%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-ajie&orientation=squarish',
    publishDate: '2024-11-08',
    readTime: 6,
    tags: ['春川', '南怡岛', '一日游', '近郊', '冬季恋歌'],
  },
  {
    id: 15,
    title: 'HYBE Insight参观记：BTS粉丝的终极朝圣之旅',
    slug: 'hybe-insight-bts-museum-visit',
    category: 'kpop',
    excerpt: '走进HYBE总部大楼，近距离感受BTS、SEVENTEEN等顶级偶像的音乐世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20entertainment%20company%20building%20lobby%20with%20music%20awards%20displayed%2C%20interactive%20exhibition%20space%2C%20bright%20contemporary%20design%2C%20editorial%20photography%2C%20soft%20cream%20and%20warm%20lighting&width=1200&height=675&seq=article-hybe&orientation=landscape',
    author: '追星少女阿圆',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20excited%20expression%20portrait%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20kpop%20fan%20style%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-ayuan&orientation=squarish',
    publishDate: '2024-11-05',
    readTime: 8,
    tags: ['HYBE', 'BTS', '博物馆', 'K-POP', '朝圣'],
  },
];

export const faqData = [
  {
    question: '去韩国旅行需要签证吗？',
    answer: '持中国普通护照前往韩国需要办理签证。如果是前往济州岛，可以享受免签政策（停留不超过30天）。建议提前至少2周办理签证，具体材料要求请咨询韩国驻华使领馆。',
  },
  {
    question: '韩国什么时候去最好玩？',
    answer: '韩国四季分明，各有特色。春天（3-5月）赏樱花，秋天（9-11月）看红叶是最佳季节。夏天（6-8月）适合去济州岛和釜山海边，冬天（12-2月）可以滑雪和体验各种冬季庆典。',
  },
  {
    question: '在韩国不会韩语怎么办？',
    answer: '完全不用担心！首尔等大城市的主要景点、地铁站都有中英文标识。很多餐厅有图片菜单或中文菜单。推荐下载Papago翻译APP，拍照就能翻译韩文，非常方便。年轻人大多能用简单英语交流。',
  },
  {
    question: '韩国旅行大概需要多少预算？',
    answer: '以5天4夜首尔自由行为例：经济型约4000-6000元/人（含机票、住宿、餐饮、交通），舒适型约8000-12000元/人。如果加上购物，预算另算。济州岛整体消费略低于首尔。',
  },
  {
    question: '韩国退税怎么操作？',
    answer: '在标有"Tax Free"的商店购物满30000韩元即可申请退税。结账时出示护照，店员会给你退税单。离境时在机场退税柜台办理，可选择现金退税或退到信用卡。部分市区也有即时退税点。',
  },
  {
    question: '韩国上网和交通卡怎么买？',
    answer: '建议提前在网上购买韩国SIM卡或WiFi蛋，到达后插卡即用。交通方面购买T-money卡，可以在便利店充值，地铁、公交、出租车通用，还能在便利店消费，非常方便。',
  },
];

export const aboutInfo = {
  brandName: '年轻的朋友韩国',
  tagline: '专为年轻人打造的韩国旅行指南',
  foundingYear: '2024',
  mission: '让每一位热爱韩流文化的年轻人都能轻松玩转韩国，发现属于自己的精彩旅行故事。',
  story: '年轻的朋友韩国诞生于一群热爱韩国文化的年轻人之手。我们深知，对于年轻人来说，旅行不只是打卡景点，更是一次探索文化、结交朋友、寻找自我的旅程。\n\n我们的团队成员包括长期生活在首尔的中国留学生、美食博主、K-POP资深粉丝和旅行摄影师。我们用自己的亲身体验，为你筛选出真正值得去的地方、值得吃的美食、值得买的好物。\n\n拒绝千篇一律的攻略，拒绝商业化的推荐。年轻的朋友韩国始终坚持真实、有趣、有温度的内容创作理念，让每一次韩国之旅都成为难忘的回忆。',
  stats: [
    { value: '200+', label: '原创攻略' },
    { value: '50万+', label: '月活用户' },
    { value: '6', label: '内容板块' },
    { value: '98%', label: '用户好评率' },
  ],
  contact: {
    email: 'hello@youngfriendkorea.com',
    wechat: 'youngfriendkorea',
    weibo: '@年轻的朋友韩国',
    xiaohongshu: '@年轻的朋友韩国',
  },
};

export const testimonials = [
  {
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20gentle%20smile%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20editorial%20portrait%20photography%2C%20professional%20look&width=200&height=200&seq=testimonial-1&orientation=squarish',
    content: '第一次去韩国就是跟着年轻的朋友韩国的攻略走的，从签证到行程安排得明明白白，连我妈都夸我靠谱！',
    role: '大学生',
  },
  {
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20editorial%20portrait%20photography%2C%20casual%20style&width=200&height=200&seq=testimonial-2&orientation=squarish',
    content: '济州岛自驾攻略真的绝了！照着路线开发现了好多连韩国朋友都不知道的小众景点，朋友圈被赞爆。',
    role: '摄影师',
  },
  {
    name: '小圆',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20bright%20smile%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20portrait%20photography%2C%20modern%20style&width=200&height=200&seq=testimonial-3&orientation=squarish',
    content: '作为ARMY，跟着追星攻略打卡了BTS同款餐厅和拍摄地，感觉离偶像更近了一步，超级幸福！',
    role: 'K-POP粉丝',
  },
];

export const heroSlides = [
  {
    image: 'https://readdy.ai/api/search-image?query=Seoul%20city%20skyline%20at%20sunset%20with%20Namsan%20Tower%2C%20warm%20golden%20and%20pink%20sky%2C%20colorful%20city%20lights%20starting%20to%20glow%2C%20young%20travelers%20silhouettes%20on%20viewing%20platform%2C%20cinematic%20atmosphere%2C%20epic%20travel%20photography%2C%20soft%20warm%20lighting&width=1600&height=900&seq=hero-01&orientation=landscape',
    title: '探索年轻的首尔',
    subtitle: '发现属于你的韩国故事',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20street%20food%20night%20market%20with%20steaming%20food%20stalls%2C%20colorful%20lanterns%20and%20neon%20signs%2C%20young%20people%20enjoying%20food%2C%20vibrant%20atmosphere%2C%20cinematic%20photography%2C%20warm%20golden%20and%20terracotta%20tones&width=1600&height=900&seq=hero-02&orientation=landscape',
    title: '吃遍韩国地道美味',
    subtitle: '从街头小吃到米其林餐厅',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Kpop%20concert%20with%20thousands%20of%20light%20sticks%20creating%20ocean%20of%20lights%2C%20excited%20young%20fans%2C%20colorful%20stage%20lighting%2C%20dynamic%20atmosphere%2C%20cinematic%20photography%2C%20pink%20and%20purple%20tones&width=1600&height=900&seq=hero-03&orientation=landscape',
    title: '追星少女的朝圣地图',
    subtitle: '从经纪公司到偶像同款打卡',
  },
];